import script from "./Step2SolicitudRecibida.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2SolicitudRecibida.vue?vue&type=script&setup=true&lang=js"

import "./Step2SolicitudRecibida.vue?vue&type=style&index=0&id=a7337026&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7337026"]])

export default __exports__